import React from "react";
import Menu from "./Menu";
import Footer from "./Footer";
import '../fonts/LithosPro-Black.woff';
import "./App.css";

function App() {
  
  return (
    <div>
      <header className="top"></header>
      <section className="mpstoparea">
        <Menu />
      </section>
      <Footer />
    </div>
  );
}

export default App;
